module.exports = __webpack_public_path__ + "static/img/icon-zsx2.e94d65cb.png";